import MedicalAdapter from './base';

export default class Batch extends MedicalAdapter {
  modelNamePlural = 'batches';
}
